import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { HelmetProvider } from 'react-helmet-async';
export function AppRouter() {
  return <HelmetProvider data-id="element-19">
      <BrowserRouter data-id="element-20">
        <Routes data-id="element-21">
          <Route path="/" element={<App data-id="element-23" />} data-id="element-22" />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>;
}